import loadable from '@loadable/component';
const Slider = loadable(() => import('react-slick'));
import './styles.scss';

export default Slider;
